// extracted by mini-css-extract-plugin
export default {"social":"Social_social__qpQTD","x":"Social_x__lTr21","link":"Social_link__-C1-o","face":"Social_face__JwwHN","git":"Social_git__n7dRc","insta":"Social_insta__-QXqW"};